<script setup lang="ts">
import SectionTitle from '../SectionTitle.vue';
import SpecialtyChip from './SpecialtyChip.vue';
import { type FragmentType, graphql } from '@/gql';

const props = defineProps<{
  planner: FragmentType<typeof PlannerDetailSpecialtySectionFragment>;
}>();

const PlannerDetailSpecialtySectionFragment = graphql(`
  fragment PlannerDetailSpecialtySection on Planner {
    specialties {
      id
      name
    }
  }
`);

const specialtiesObj = computed(
  () =>
    getFragment(PlannerDetailSpecialtySectionFragment, props.planner)
      .specialties ?? []
);
</script>

<template>
  <section :class="$style.specialties">
    <SectionTitle title="得意分野" />
    <ul :class="$style.specialties__list">
      <li
        v-for="specialty in specialtiesObj"
        :key="specialty.id"
        :class="$style.specialties__item"
      >
        <SpecialtyChip :specialty="specialty.name" />
      </li>
    </ul>
  </section>
</template>

<style lang="scss" module>
.specialties {
  &__list {
    padding-top: 14px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    align-items: flex-start;
    margin: -8px 0 0 -8px;
  }

  &__item {
    margin: 8px 0 0 8px;
  }
}
</style>
